import React from 'react';
import { CTAButton } from '../CTAButton';
import { MOCKUP_IMAGE } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-10 pt-7 sm:pb-14 sm:pt-10" data-id="element-169" data-mp="7xjfm3oe6la6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-170" data-mp="cvl5b7gbpium">
        <p className="font-display text-xl font-bold text-forest sm:text-2xl" data-id="element-171" data-mp="cy7dn9b1g2dw">Dr. Karito</p>
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.2em] text-navy/70 sm:text-xs" data-id="element-172" data-mp="hsuuclzsvshx">
          Clinical Kit for Obesity Management
        </p>

        <h1 className="mt-4 font-display text-[30px] font-black leading-[1.1] tracking-tight text-navy-deep sm:text-5xl" data-id="element-173" data-mp="qub4qtqm7um5">
          Follow a <span className="text-forest-mid" data-id="element-174" data-mp="vofaxas23ym6">Clinical Pathway</span> that lets you make faster
          and safer decisions in obesity management
        </h1>

        <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-ink/70 sm:text-lg" data-id="element-175" data-mp="15ll3yok8dzp1">
          Without relying on multiple guidelines or wasting time searching for information during your
          consultation.
        </p>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-176" data-mp="9lg9ewfyj0sp">
          <img src={MOCKUP_IMAGE} alt="Clinical Kit for Obesity Management: 6 specialized volumes plus digital material for computer, tablet, and phone" className="mx-auto w-full max-w-[520px]" loading="eager" data-id="element-177" data-mp="4noh41behcnz" />
        </div>

        <p className="mx-auto mt-2 max-w-lg text-[13px] font-semibold text-ink/60 sm:text-sm" data-id="element-178" data-mp="setzoo8q6j1z">
          6 specialized volumes + digital material for computer, tablet, and phone.
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-179" data-mp="inz957og4xaq">
          <CTAButton label="I want the Clinical Kit now" sub="Today only $27 USD • Instant Download • Lifetime Access • 7-Day Guarantee" data-id="element-180" data-mp="imo6jb6qlvl7" />
        </div>
        <div id="cta-sentinel" aria-hidden="true" className="h-px w-full" data-id="element-181" data-mp="1b5lazvc9wjj0" />
      </div>
    </header>;
}